import React, {useEffect} from "react";
import {icons} from "@/assets/icons/Icons";
import {config} from "@/config";

const isForth = config.websiteId === 1;
const isEdge = config.websiteId === 2;
const isBiomarkerTracking = !isForth && !isEdge;

export default function Icon(props) {
  const {icon = "heart-health", className = "", overwriteColours = true, colours = [], style = {}} = props;

  let SelectedIcon = icons[icon];

  if (!icons[icon]) {
    SelectedIcon = icons["heart-health"];
  }

  const svgId = `icon-${icon}`;
  const defaultColorOne = isForth ? "var(--bs-gold-900)" : isEdge ? "var(--bs-grey-100)" : "var(--bs-icon)";
  const defaultColorTwo = isForth ? "var(--bs-gold-100)" : isEdge ? "var(--bs-grey-100)" : "var(--bs-icon)";

  useEffect(() => {
    if (overwriteColours === true) {
      document.querySelectorAll(`#${CSS.escape(svgId)}`)?.forEach(el => {
        const randomId = Math.random()
          .toString(36)
          .substring(2, 10 + 2);
        el.querySelector("defs linearGradient")?.setAttribute("id", randomId);

        if (el.querySelector("defs linearGradient")) {
          const svgElement = el.getAttribute("id");
          const linearGradientId = el.querySelector("defs linearGradient")?.getAttribute("id");

          const colourOne = colours[0] ? colours[0] : defaultColorOne;
          const colourTwo = colours[1] ? colours[1] : defaultColorTwo;

          if (config.websiteId != 1 && !["icon-edge-brand-icon"].includes(svgElement)) {
            el.querySelector("defs > linearGradient > stop:nth-of-type(1)")?.setAttribute("stop-color", colourOne);
            el.querySelector("defs > linearGradient > stop:nth-of-type(2)")?.setAttribute("stop-color", colourTwo);
          }

          el.querySelectorAll("path[fill^='url(']")?.forEach(path =>
            path?.setAttribute("fill", `url(#${linearGradientId})`),
          );
        }
      });

      if (overwriteColours && config.websiteId != 1) {
        const g = document.querySelectorAll(`svg#${svgId} path`);
        const colourOne = colours[0] ? colours[0] : defaultColorOne;
        const colourTwo = colours[1] ? colours[1] : colourOne;

        g?.forEach(function (item) {
          if (["#d9cdc6", "#dacdc6", "#c3bffa", "#CBC3BA", "#302F2F"].includes(item.getAttribute("fill"))) {
            item?.setAttribute("fill", colourOne);
          }
          if (["#d9cdc6", "#dacdc6", "#c3bffa", "#CBC3BA", "#302F2F"].includes(item.getAttribute("stroke"))) {
            item?.setAttribute("stroke", colourTwo);
          }
        });
      }
    }
  }, [svgId, overwriteColours, colours]);

  return (
    <div className={className} style={style}>
      <SelectedIcon id={svgId} width="100%" height="100%" aria-hidden="true" focusable="false" />
    </div>
  );
}
